<template>
  <VApp>
    <VLayout class="rounded rounded-md border">
      <VAppBar :elevation="2" color="primary">
        <template v-slot:prepend>
          <v-app-bar-nav-icon @click.stop="showDrawer = !showDrawer"></v-app-bar-nav-icon>
        </template>

        <v-app-bar-title>PEREY | ME</v-app-bar-title>

        <VBtn prepend-icon="mdi-linkedin" stacked variant="text"
          href="https://www.linkedin.com/in/cpperey" target="_blank"></VBtn>
      </VAppBar>
      <VNavigationDrawer v-model="showDrawer">
        <VList class="text-left">
          <VListItem to="/" @click="showDrawer = false">
            <VListItemTitle><VIcon icon="mdi-information"></VIcon> About Me</VListItemTitle>
          </VListItem>
          <VListItem to="/experience" @click="showDrawer = false">
            <VListItemTitle><VIcon icon="mdi-briefcase"></VIcon> Experience</VListItemTitle>
          </VListItem>
        </VList>
      </VNavigationDrawer>
      <VMain>
        <RouterView v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </RouterView>
      </VMain>
    </VLayout>
  </VApp>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      showDrawer: false
    };
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
